<sup>
  <slot />
</sup>

<style lang="scss">
  sup {
    display: inline-block;
    vertical-align: super;
    font-size: smaller;
    line-height: 0;
  }
</style>
